import Fragment from "./fragment";
import FragmentSummary from "./fragment-summary";

/**
 * Deuce attempt fragment for Indoor Football.
 * A Deuce is when the kickoff goes through the uprights for 2 points.
 * This is just a marker fragment - the kickedTo position comes from the KickOff fragment.
 */
export default class Deuce extends Fragment {
    constructor() {
        super();
        this.code = "DCE";
    }

    summarize(summaryContext) {
        return new FragmentSummary("deuce attempt");
    }

    updateSummaryContext() {
        // No context updates needed - kickedTo comes from KickOff fragment
    }

    toJSON() {
        return {
            ...super.toJSON()
        };
    }
}
